module.exports = __webpack_public_path__ + "img/educacion.9078ddb6.jpg";